<template>
  <div class="rv-holder">
    <div class="recent-holder" v-if="showing" ref="tholder">
      <div class="hid-similars" :class="{showing: visible}">
        <div class="close-box small white tight" v-on:click="hideMe"></div>
        <div class="mbrowser">
          <az-browse-panel :artists="artists" white />
        </div>
      </div>
    </div>
    <div class="similar-holder" v-if="showingSimilars">
      <div class="hid-similars" :class="{showing: visibleSimilars}">
        <div class="close-box small white tight" v-on:click="hideSimilars"></div>
        <div class="mbrowser">
          <az-browse-panel :artists="similarData.related" :artist="similarData.artist" white />
        </div>
      </div>
    </div>
    <div class="recent-button" v-if="mwidth > 640" :class="{showing: showing}" v-show="!empty">
      <div class="vertical-button" v-on:click="showMe">{{ $nippets.recentlyViewed }}</div>
      <div class="vertical-button similars" v-on:click="toggleSimilars" v-if="showSimilars && hasSimilars">{{ $nippets.similars }}</div>
      <div class="vertical-button testimonials" v-on:click="handleTestimonials" v-if="$store.state.showTestimonialButton">{{ $nippets.testimonials }}</div>
    </div>
  </div>
</template>

<script>
import AzBrowsePanel from '@/components/panels/AzBrowseFancy.vue'
import MeasurablePage from '@/mixins/MeasurablePage.js'
export default {
  mixins: [MeasurablePage],
  components: {
    AzBrowsePanel
  },
  data () {
    return {
      showing: false,
      visible: false,
      artists: [],
      loaded: false,
      showSimilars: false,
      showingSimilars: false,
      visibleSimilars: false
    }
  },
  computed: {
    empty () {
      return this.$store.getters.recents.length < 1
    },
    similarData () {
      return this.$store.state.similars
    },
    hasSimilars() {
      return (this.$store.getters.countSimilars > 0)
    },
    popSimilars: {
      get: function () {
        return this.$store.state.popSimilars
      },
      set: function(val) {
        this.$store.commit('setPopSimilars', val)
      }
    },
    unpopSimilars: {
      get: function () {
        return this.$store.state.unpopSimilars
      },
      set: function (val) {
        this.$store.commit('setUnpopSimilars', val)
      }
    }
    
  },
  created () {
    this.testSimilars()
  },
  methods: {
    async showMe() {
      if(!this.loaded) {
        this.artists = await this.$store.getters.recents
      }
      if(this.showing) {
        this.hideMe()
        return
      }
      this.visibleSimilars = false
      this.showingSimilars = false
      this.showing = true
      await this.$k.waitfor(200)
      this.visible = true
      this.$k.sendGaEvent('RecentlyViewed','Clicked', this.$route.path)
      this.$store.commit('setShowingTabs', true)
    },
    async hideMe() {
      this.visible = false
      await this.$k.waitfor(200)
      this.showing = false
      this.$store.commit('setShowingTabs', false)
    },
    toggleSimilars() {
      if(!this.showingSimilars){
        this.showSimilarPanel()
      }
      else {
        this.hideSimilars()
      }
      
    },
    async hideSimilars() {
      this.visibleSimilars = false
      await this.$k.waitfor(200)
      this.showingSimilars = false
      this.$store.commit('setShowingTabs', false)
    },
    async showSimilarPanel() {
      this.showingSimilars = true
      await this.$k.waitfor(200)
      this.visibleSimilars = true
      this.showing = false
      this.visible = false
      this.$store.commit('setShowingTabs', true)
    },
    handleTestimonials () {
      this.hideMe()
      this.hideSimilars()
      this.$store.commit('setPopTesti', 'open')
    },
    canSimilar () {
      if(this.$route) {
        if ((this.$route.name === 'illustration portfolio')||(this.$route.name === 'illustrator style selection')) {
          return true
        }
      }
      return false
    },
    testSimilars () {
      this.showSimilars = this.canSimilar()
    }
  },
  watch: {
    '$route.path': function () {
      this.hideSimilars()
      this.testSimilars()
    },
    popSimilars (newVal, oldVal) {
      console.log('Got pop similars')
      if(newVal && !oldVal) {
        if(this.canSimilar()) {
          if(!this.visibleSimilars) {
            this.showSimilarPanel()
          }
          this.popSimilars = false
        }
      }
    },
    unpopSimilars (newVal, oldVal) {
      if(newVal && !oldVal) {
        this.hideSimilars()
      }
      this.unpopSimilars = false
    }
  }
}
</script>

<style scoped>
.rv-holder{
  position:fixed;
  bottom:0;
  left:0;
  right:0;
  box-sizing:border-box;
  z-index:51;
}

.recent-holder{
  z-index:45;
  width:100%;
  box-sizing:border-box;
  background-color:#98b8ad;
  box-shadow:0 -10px 10px rgba(0,0,0,0.5);
}

.similar-holder{
  z-index:45;
  width:100%;
  box-sizing:border-box;
  background-color:#8b6f4b;
  box-shadow:0 -10px 10px rgba(0,0,0,0.5);
}

.recent-button{
  position:absolute;
  top:-31px;
  left:40px;
  display:flex;
}

.mbrowser{
  padding:20px 50px;
}


.recent-button .vertical-button{
  color:#fff;
  background-color:#98b8ad;
  
  padding:6px 15px 6px 39px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size:16px;
  z-index:51;
  background-image:url('../../assets/img/plus-button.svg');
  background-size:16px 16px;
  background-position:12px 50%;
  cursor:pointer;
}

.recent-button .vertical-button.similars{
  background-color:#8b6f4b;
  margin-left:16px;
}

.recent-button .vertical-button.testimonials{
  background-color:#ac9e3c;
  margin-left:16px;
}


.recent-button .vertical-button:hover{
  background-color:#ce0e2d;
}

.fullwidth.slim{
  padding-top:24px;
  padding-bottom:10px;
  background-color:#98b8ad;
}

.similar-holder .fullwidth.slim{
  background-color:#8b6f4b;
}

.hid-similars{
  max-height:0;
  overflow:hidden;
  transition:all ease 0.3s;
}

.hid-similars.showing{
  max-height:500px;
}

@media screen and (max-width:767px){
  .recent-button .vertical-button{
    display:none;
  }
  .recent-holder, .recent-button{
    display:none;
  }
}
</style>